// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Notify from "@bg/App/Components/Notify";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkProps } from "@insite/mobius/Link";
import parse from "html-react-parser";
import * as React from "react";

type Props = WidgetProps & HasProduct;

const SuggestedProductsNotification: React.FC<Props> = ({ product }) => {
    if (!product || product.properties?.haveSuggestedNextRelatedProduct !== "true") {
        return null;
    }
    const isRequried = product.properties?.suggestedNextAreRequired?.toLowerCase() === "true";

    const scrollToSuggested = () => {
        const headerElement = document.querySelector("#header");
        const suggestedCarousel = document.querySelector("#productSuggestions");
        if (suggestedCarousel) {
            const { top } = suggestedCarousel.getBoundingClientRect();
            const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 0;
            window.scrollTo({
                top: top + window.pageYOffset - headerHeight,
                left: 0,
                behavior: "smooth",
            });
        }
    };

    return (
        <Notify
            messageType={isRequried ? "danger" : "warning"}
            body={
                <>
                    {product.properties?.suggestedNextNotificationText
                        ? parse(product.properties?.suggestedNextNotificationText)
                        : siteMessage("Custom_PDP_SuggestedNextNotification")}
                    <Link onClick={scrollToSuggested}>&nbsp;{translate("View Products")}</Link>
                </>
            }
            showCloseButton
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(SuggestedProductsNotification),
    definition: {
        displayName: "Suggested Products Notification",
        group: "XNGAGE" as any,
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
